module.exports = __webpack_public_path__ + "img/logo.0c34c388.png";